/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Company } from '../models/company';
import { createOneBaseMgmtDistributorControllerCompany } from '../fn/distributor/create-one-base-mgmt-distributor-controller-company';
import { CreateOneBaseMgmtDistributorControllerCompany$Params } from '../fn/distributor/create-one-base-mgmt-distributor-controller-company';
import { deleteOneBaseMgmtDistributorControllerCompany } from '../fn/distributor/delete-one-base-mgmt-distributor-controller-company';
import { DeleteOneBaseMgmtDistributorControllerCompany$Params } from '../fn/distributor/delete-one-base-mgmt-distributor-controller-company';
import { getManyBaseMgmtDistributorControllerCompany } from '../fn/distributor/get-many-base-mgmt-distributor-controller-company';
import { GetManyBaseMgmtDistributorControllerCompany$Params } from '../fn/distributor/get-many-base-mgmt-distributor-controller-company';
import { GetManyCompanyResponseDto } from '../models/get-many-company-response-dto';
import { getOneBaseMgmtDistributorControllerCompany } from '../fn/distributor/get-one-base-mgmt-distributor-controller-company';
import { GetOneBaseMgmtDistributorControllerCompany$Params } from '../fn/distributor/get-one-base-mgmt-distributor-controller-company';
import { updateOneBaseMgmtDistributorControllerCompany } from '../fn/distributor/update-one-base-mgmt-distributor-controller-company';
import { UpdateOneBaseMgmtDistributorControllerCompany$Params } from '../fn/distributor/update-one-base-mgmt-distributor-controller-company';

@Injectable({ providedIn: 'root' })
export class DistributorApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtDistributorControllerCompany()` */
  static readonly GetManyBaseMgmtDistributorControllerCompanyPath = '/api/mgmt/distributors';

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtDistributorControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtDistributorControllerCompany$Response(params?: GetManyBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyCompanyResponseDto>> {
    const obs = getManyBaseMgmtDistributorControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Companies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtDistributorControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtDistributorControllerCompany(params?: GetManyBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<GetManyCompanyResponseDto> {
    const resp = this.getManyBaseMgmtDistributorControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyCompanyResponseDto>): GetManyCompanyResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtDistributorControllerCompany()` */
  static readonly CreateOneBaseMgmtDistributorControllerCompanyPath = '/api/mgmt/distributors';

  /**
   * Create a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtDistributorControllerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtDistributorControllerCompany$Response(params: CreateOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = createOneBaseMgmtDistributorControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtDistributorControllerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtDistributorControllerCompany(params: CreateOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.createOneBaseMgmtDistributorControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtDistributorControllerCompany()` */
  static readonly GetOneBaseMgmtDistributorControllerCompanyPath = '/api/mgmt/distributors/{id}';

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtDistributorControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtDistributorControllerCompany$Response(params: GetOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = getOneBaseMgmtDistributorControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtDistributorControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtDistributorControllerCompany(params: GetOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.getOneBaseMgmtDistributorControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtDistributorControllerCompany()` */
  static readonly DeleteOneBaseMgmtDistributorControllerCompanyPath = '/api/mgmt/distributors/{id}';

  /**
   * Delete a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtDistributorControllerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtDistributorControllerCompany$Response(params: DeleteOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtDistributorControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtDistributorControllerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtDistributorControllerCompany(params: DeleteOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtDistributorControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtDistributorControllerCompany()` */
  static readonly UpdateOneBaseMgmtDistributorControllerCompanyPath = '/api/mgmt/distributors/{id}';

  /**
   * Update a single Company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtDistributorControllerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtDistributorControllerCompany$Response(params: UpdateOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    const obs = updateOneBaseMgmtDistributorControllerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single Company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtDistributorControllerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtDistributorControllerCompany(params: UpdateOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<Company> {
    const resp = this.updateOneBaseMgmtDistributorControllerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

}
